import * as Yup from 'yup';

export const engineSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
});
